<ng-container *ngIf="lazyLoad === false; else lazyTemplate">
    <div class="dynamic-content"  #bannerUnitRef></div>
</ng-container>
<ng-template #lazyTemplate>
    <div class="dynamic-content lazy" #bannerUnitRef (lazyLoad)="placeBannerUnit()"></div>
</ng-template>
